/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Events_Spots_LeftInputs */

const en_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} spot(s) left`)
};

const es_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} cupos disponibles`)
};

const de_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noch ${i?.n} Plätze frei`)
};

const zh_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`剩余 ${i?.n} 个名额`)
};

const ar_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تبقّى ${i?.n} مقعد`)
};

const fr_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} place(s) restante(s)`)
};

const vi_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Còn ${i?.n} chỗ`)
};

const sw_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zimebaki nafasi ${i?.n}`)
};

const th_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เหลือ ${i?.n} ที่`)
};

const bs_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} slobodnih mjesta`)
};

const ja_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`残り ${i?.n} 枠`)
};

const ko_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}자리 남음`)
};

const pt_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} vaga(s) restante(s)`)
};

const it_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ancora ${i?.n} posti`)
};

const sv_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} plats(er) kvar`)
};

const nl_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nog ${i?.n} plek(ken) vrij`)
};

const da_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} plads(er) tilbage`)
};

const nb_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} plass(er) igjen`)
};

const fi_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} paikkaa jäljellä`)
};

const pl_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pozostało miejsc: ${i?.n}`)
};

const ru_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Осталось мест: ${i?.n}`)
};

const tr_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} yer kaldı`)
};

const hi_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} स्थान शेष`)
};

const id_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tersisa ${i?.n} tempat`)
};

const ms_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} tempat lagi`)
};

const cs_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zbývá míst: ${i?.n}`)
};

const el_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Απομένουν ${i?.n} θέσεις`)
};

const he_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`נותרו ${i?.n} מקומות`)
};

const af_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} plek(ke) oor`)
};

const hu_events_spots_left = /** @type {(inputs: Events_Spots_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Még ${i?.n} szabad hely`)
};

/**
* | output |
* | --- |
* | "{n} spot(s) left" |
*
* @param {Events_Spots_LeftInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_spots_left = /** @type {((inputs: Events_Spots_LeftInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Spots_LeftInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_spots_left(inputs)
	if (locale === "de") return de_events_spots_left(inputs)
	if (locale === "zh") return zh_events_spots_left(inputs)
	if (locale === "ar") return ar_events_spots_left(inputs)
	if (locale === "fr") return fr_events_spots_left(inputs)
	if (locale === "vi") return vi_events_spots_left(inputs)
	if (locale === "sw") return sw_events_spots_left(inputs)
	if (locale === "th") return th_events_spots_left(inputs)
	if (locale === "bs") return bs_events_spots_left(inputs)
	if (locale === "ja") return ja_events_spots_left(inputs)
	if (locale === "ko") return ko_events_spots_left(inputs)
	if (locale === "pt") return pt_events_spots_left(inputs)
	if (locale === "it") return it_events_spots_left(inputs)
	if (locale === "sv") return sv_events_spots_left(inputs)
	if (locale === "nl") return nl_events_spots_left(inputs)
	if (locale === "da") return da_events_spots_left(inputs)
	if (locale === "nb") return nb_events_spots_left(inputs)
	if (locale === "fi") return fi_events_spots_left(inputs)
	if (locale === "pl") return pl_events_spots_left(inputs)
	if (locale === "ru") return ru_events_spots_left(inputs)
	if (locale === "tr") return tr_events_spots_left(inputs)
	if (locale === "hi") return hi_events_spots_left(inputs)
	if (locale === "id") return id_events_spots_left(inputs)
	if (locale === "ms") return ms_events_spots_left(inputs)
	if (locale === "cs") return cs_events_spots_left(inputs)
	if (locale === "el") return el_events_spots_left(inputs)
	if (locale === "he") return he_events_spots_left(inputs)
	if (locale === "af") return af_events_spots_left(inputs)
	if (locale === "hu") return hu_events_spots_left(inputs)
	return en_events_spots_left(inputs)
});